var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['card-wrapper', _vm.columnClasses]},[_c('card',_vm._b({},'card',_vm.$attrs,false),[_vm._l((_vm.$slots),function(_,name){return _vm._t(name,null,{"slot":name})})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }